var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    ref: "associateMaterialsModal",
    attrs: {
      "scrollable": "",
      "centered": "",
      "cancel-disabled": "",
      "ok-disabled": "",
      "no-stacking": "",
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "lg"
    }
  }, [_c('VHeader', {
    attrs: {
      "modal-button": true
    },
    on: {
      "close-modal": _vm.closeModal
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function () {
        return [_vm._v("Biological Materials Associated with Research Project")];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('BioProjectMaterials', {
    attrs: {
      "group-nid": _vm.groupNid,
      "default-project-nid": _vm.defaultProjectNid
    },
    on: {
      "close-modal": _vm.closeModal
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }